
import React from 'react';
import {connect} from 'react-redux';
import {goToPage, setSelectedDeliveryDay, setSelectedDeliveryTime} from '../../ServiceAppointmentBlockSlice';
import {goToNextPageAsync} from '../../ServiceAppointmentAsyncthunk';
import TimeSlots from '../../../../Shared/TimeSlots/TimeSlots';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';

const DeliveryPage = (props) => {

  function handleSelectDay(day) {
    props.setSelectedDeliveryDay(day);
  };

  function handleSelectHours(hours) {
    props.setSelectedDeliveryTime(hours);
  }

  function goToPickUpPage(){
    EpiContext.navigateTo(props.linkCollectionPoints);
  }

  function handleOnContinue() {
     props.goToNextPageAsync();
  }

    return (
      <div className='delivery-page page-wrapper'>
        <div className='content'>
          <div className='title-wrapper'>
            <div className='title'>מתי ניפגש?</div>
            <div className='sub-title'>משלוח יגיע לכתובת: <span className='full-address'>{props.fullAddress}</span></div>
          </div>
          <TimeSlots technicianTimes={props.timeSlots} onSelectDay={handleSelectDay} onSelectHours={handleSelectHours} />
        </div>
        <div className='button-wrapper'>
          <BtnSubmit isBusiness={false} text={'אישור הזמנת משלוח'} onclick={handleOnContinue} formid='delivery-page' isDisplayArrows={false} />
          {props.linkCollectionPoints && (
            <BtnWhiteBlackBorderBigSize
              text='אני רוצה לאסוף עכשיו את ספק הכוח' onclick={() => { goToPickUpPage(); }} />
          )}
        </div>
      </div>
    );
}

const mapStateToProps = (state) => {
  return {
    timeSlots: state.serviceAppointmentSchedulerBlock.delivery.timeSlots,
    fullAddress: state.serviceAppointmentSchedulerBlock.delivery.address.fullAddress,
    linkCollectionPoints: state.serviceAppointmentSchedulerBlock.dataEpi.linkCollectionPoints?.url
  };
};

const mapDispatchToProps = {
  goToPage,
  goToNextPageAsync,
  setSelectedDeliveryDay,
  setSelectedDeliveryTime
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryPage);

